import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import MarketingShell from "@/components/marketing/MarketingShell";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found | ChangeOS";
    // This page must never be indexed; drop any canonical the previous page left behind.
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.remove();
    const robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    robots.setAttribute("content", "noindex, follow");
    document.head.appendChild(robots);
    return () => { robots.remove(); };  // remove on unmount so noindex never leaks onto real pages
  }, []);
  return (
    <MarketingShell>
      <section className="max-w-3xl mx-auto px-6 py-28 text-center" data-testid="notfound-page">
        <div className="pp-overline">Error 404</div>
        <h1 className="font-head font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-3">Page not found</h1>
        <p className="text-lg text-subtle mt-5">The page you're looking for doesn't exist or has moved.</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" data-testid="notfound-home" className="pp-btn-dark"><Home size={16} /> Go to home</Link>
          <Link to="/pricing" data-testid="notfound-pricing" className="pp-btn-ghost">See pricing</Link>
          <Link to="/guide" data-testid="notfound-guide" className="inline-flex items-center gap-1.5 h-11 text-sm font-bold text-muted-foreground hover:text-foreground transition-colors">Getting started guide <ArrowRight size={15} /></Link>
        </div>
      </section>
    </MarketingShell>
  );
}
